import { useCallback, useEffect, useState } from 'react'

interface CountdownTimerProps {
  expiresAt?: string | null
  shortFormat?: boolean
}

const CountdownTimer = ({ expiresAt, shortFormat = false }: CountdownTimerProps) => {
  if (!expiresAt) return null

  const calculateTimeLeft = useCallback(() => {
    const expirationDate = new Date(expiresAt)
    const now = new Date()
    const difference = expirationDate.getTime() - now.getTime()

    let timeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    }

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }, [expiresAt])

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearInterval(timer)
  }, [calculateTimeLeft])

  return (
    <p>
      {shortFormat
        ? `${timeLeft.days}d | ${timeLeft.hours}h | ${timeLeft.minutes}m | ${timeLeft.seconds}s`
        : `${timeLeft.days} Days | ${timeLeft.hours} Hours | ${timeLeft.minutes} Minutes | ${timeLeft.seconds} Seconds Left`}
    </p>
  )
}

export default CountdownTimer
